import { select_virtel_where_parent_subkey } from '../utils/frfr-virtel-selectors.js';
import { virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import element from "./ter-export-lib-sastavnica-21r3-element-lib";
import { _get_ident_nadredjenog_from_sastavnica_internal, _make_sastavnica_for_ext_api_export, _spakuj_objekat_u_sastavnica_internal_row_arr } from "./ter-sastavnica-utils";
import { _is_bomlevel1_ancestor_of_bomlevel2 } from '../utils/frfr-bomlevel-utils.js';


/*
NAJNOVIJE PODSETNIK:

- graphlevel i nivo u sastavnici nije identična stvar. 
graphlevel označava level po teoriji grafova i on je uvek ceo broj. Hijerarhijski najviši nivo je 1, njegova deca u 2 itd.
Nivo u sastavnici može biti složeniji i on ze pojedinu stavku u sastvnici može da glasi na primer "1.2.1.4" dakle on nije ceo broj nego string gde se tačka koristi kao delimeter.


provera da li je nsto materijal se radi ovako
  const sema = virtel_schema_smart_get(virtel.virtelschemakey);
  if (sema && sema.program && sema.program.mip_is_materijal === true) {
    // materijal
  } else {
    // poluproizvod
  }


  const virbom_seq = draft.virtel_width_ident_arr
  klimakomora_arr = 


  foreach klimakomora_arr 

  mm_od_jedne_komore = select_virtel_where_parent_subkey()

  svaki poluproizvod  od modula
  pp_od_modula = select_virtel_where_parent_subkey()


  svi children od nekog poluproizvoda
  pp_children_od_pp = select_virtel_where_parent_subkey()

  svaki pojedincani popluproizvod ili materijal ili k i m kojem znamo ID
  virtel = select_virtel_single_by_subkey()

*/


/*
TODO:

*/


// --------------------------------------


export const _make_sastavnica_internal_from_virbom_seq = (virbom_seq, virbom_rev_id) => {
  console.log('_make sastavnica - ulazni virbom_seq', virbom_seq);

  let kompletni_sas_internal = [];

  let _last_kojigod_ident = '';
  let _last_kojigod_bomlevel = false;
  let _last_modul_ident = '';
  // let _last_modul_graphlevel = false;
  let _last_modul_bomlevel = false;
  let _last_klimakomora_ident = '';
  // let _last_klimakomora_graphlevel = false;
  let _last_klimakomora_bomlevel = false;


  console.log('*** iteracije dodavanja redova sastavnice zapocete...');
  // STARTOVANJE iteracija i izrade sastavnica pocev od level 1


  // u ovoj novoj verziji funkcije podrazumevamo da je virtel_seq sekvenca sa pravilnim redosledom i ne vrsimo Tree traversal nego klasican foreach
  virbom_seq.forEach((virtel) => {
    //
    let index = 'W'; // ??? TODO ???
    // console.log('*** sastavnica iterator > single - virtel');
    // console.log(virtel);
    const virtelschemakey = virtel.virtelschemakey;
    const sema = virtel_schema_smart_get(virtelschemakey);
    // console.log(sema);
    let terkategorija = 'Xx';
    if (sema.program && sema.program.mip_is_materijal === false) {
      terkategorija = 'PP';
    } else if (sema.program && sema.program.mip_is_materijal === true) {
      terkategorija = 'M';
      if (virtel.terkategorija === 'OP') {
        terkategorija = 'OP';
      }
    }
    //

    const _get_ident_nadredjenog = () => {
      //
      let _ident_nadredjenog = '';
      // let _ident_komore = '';
      let _ident_modula = '';
      /*
      if (_is_bomlevel1_ancestor_of_bomlevel2(_last_klimakomora_bomlevel, virtel.bomlevel)) {
        _ident_nadredjenog = _last_klimakomora_ident;
      }
      */
      // console.log('_last_kojigod_ident', _last_kojigod_ident, '_last_kojigod_bomlevel', _last_kojigod_bomlevel);
      if (_is_bomlevel1_ancestor_of_bomlevel2(_last_kojigod_bomlevel, virtel.bomlevel)) {
        _ident_nadredjenog = _last_kojigod_ident; // DL 2024-04-23 ident nadrejenog je ident bilo kojeg parenta
      }
      if (_is_bomlevel1_ancestor_of_bomlevel2(_last_modul_bomlevel, virtel.bomlevel)) {
        // _ident_nadredjenog = _last_modul_ident;
        _ident_modula = _last_modul_ident;
      }
      return [_ident_nadredjenog, _ident_modula];
    };


    //
    let _row_obj = {};
    // pakujemo svaki row objekat zavisno od vrste elementa
    if (sema !== false) {
      // console.log('+++ make row', virtel.virtelclass, virtel.virtelclass === 'terkk$modul$rogalj');
      if (virtel.virtelclass === 'terkk$special_by_lang' || virtel.virtel_program_sas_by_lang === true) {
        // console.log('test special_by_lang');
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.special_by_lang(virtel, _ident_nadredjenog, _ident_modula));
      } else if (virtel.virtelclass === 'terkk$klimakomora') {
        // console.log('test klimakomora');
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.klimakomora(virtel));
        //
        _last_klimakomora_ident = _row_obj.Ident;
        _last_klimakomora_bomlevel = virtel.bomlevel;
        // _last_klimakomora_graphlevel = virtel.graphlevel;
        //
      } else if (virtel.virtelclass === 'terkk$modul') {
        // console.log('test modul');
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.modul(virtel));
        //
        _last_modul_ident = _row_obj.Ident;
        _last_modul_bomlevel = virtel.bomlevel;
        // _last_modul_graphlevel = virtel.graphlevel;
        //
        // ??? materijal ???
      } else if (virtel.virtelclass === 'terkk$materijalcustom') {
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.materijalcustom(virtel));
      } else if (virtelschemakey === 'terkk$panel') {
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.panel(virtel));
      } else if (virtelschemakey === 'terkk$panel$derivat1') {
        if (virtel.tergrupa === 'PROFIL') {
          // TODO napraviti bolje resenje u buducnosti za oznacavanej delova
          _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element._pp_grupa_PROFIL(virtel));
        } else if (virtel.tergrupa === 'ISPUNA') {
          _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.grupa_ispuna(virtel));
        } else {
          // panel uspoljasnji lim i unutrasnji lim
          //
          const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
          _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.panel$derivat1(virtel, _ident_nadredjenog, _ident_modula));
        }
      } else if (virtel.virtelclass === 'terkk$demper') {
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.demper(virtel));
      } else if (virtel.virtelclass === 'terkk$elasticnaveza') {
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.elasticnaveza(virtel));
      } else if (virtel.virtelclass === 'terkk$eliminatorkapi') {
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.eliminatorkapi(virtel));
      } else if (virtel.virtelclass === 'terkk$spoljnafiksnazaluzina') {
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.spoljnafiksnazaluzina(virtel));
      } else if (virtel.virtelclass === 'terkk$kadica' || virtel.virtelclass === 'terkk$kadica.1' || virtel.virtelclass === 'terkk$kadica.1.1') {
        // console.log('test kadica', virtel.virtelclass);
        //
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.kadica(virtel, _ident_nadredjenog, _ident_modula));
      } else if (virtel.virtelclass === "terkk$postolje") {
        //
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.postolje(virtel, _ident_nadredjenog, _ident_modula));
      } else if (virtel.virtelclass === "terkk$postolje$profil" || virtel.virtelclass === "terkk$postolje$profil_opsec" || virtel.virtelclass === "terkk$postolje$profil_opsav" || virtel.virtelclass === "terkk$postolje$profil_niski" || virtel.virtelclass === "terkk$postolje$profil_niski.1" || virtel.virtelclass === "terkk$postolje$profil_niski_opsec" || virtel.virtelclass === "terkk$postolje$profil_niski_opsav" || virtel.virtelclass === "terkk$postolje$profil_niski_opsav2") {
        //
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.postolje_profil(virtel, _ident_nadredjenog, _ident_modula));

      } else if (virtel.virtelclass === "terkk$ppv") {
        //
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.ppv(virtel, _ident_nadredjenog, _ident_modula));
      } else if (virtel.virtelclass === "terkk$ppv$sekcija" || virtel.virtelclass === "terkk$ppv$sekcija_opsec" || virtel.virtelclass === "terkk$ppv$sekcija_opsav") {
        //
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.ppv_sekcija(virtel, _ident_nadredjenog, _ident_modula));

      } else if (virtel.virtelclass === "terkk$krov$child" || virtel.virtelclass === "terkk$krov$child_op1_2" || virtel.virtelclass === "terkk$krov$child_op2_2") {
        //
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.krov_lim(virtel, _ident_nadredjenog, _ident_modula));
        /*
      } else if (virtel.virtelclass === 'terkk$profilcustom') {
        // bice ubacen kroz tergurpa PROFIL i element._pp_grupa_PROFIL
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.profilcustom(virtel));
        */
      } else if (virtel.virtelclass === 'terkk$limcustom') {
        //
        const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.limcustom(virtel, _ident_nadredjenog, _ident_modula));
      } else if (virtel.virtelclass === 'terkk$modul$rogalj') {
        // ??? materijal ???
        // console.log('test rogalj');
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.rogalj(virtel));
      } else if (virtel.virtelclass === 'terkk$materijal_lim') {
        // materijal lim NOVO
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.univerzalniMaterijal_od_tergrupa_lim(virtel));


      } else if (virtel.virtelclass === 'zzkitc$kitc') {
        // experimental
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.zzkitc_kitc(virtel));
      } else if (virtel.virtelclass === 'zzkitc$kitc$element$child') {
        // experimental
        _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.zzkitc_wbp_pp(virtel));


      } else {
        // ELSE
        // console.log('ELSE 1. - znaci nije bilo podudarnosti sa virtel.virtelclass ***');
        if (virtel.tergrupa === 'PROFIL') {
          // TODO napraviti bolje resenje u buducnosti za oznacavanje delova
          _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element._pp_grupa_PROFIL(virtel));
        } else if (virtel.tergrupa === 'LIM') {
          //
          const [_ident_nadredjenog, _ident_modula] = _get_ident_nadredjenog(kompletni_sas_internal, virtel.bomlevel);
          _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element._pp_grupa_LIM(virtel, _ident_nadredjenog, _ident_modula));
        } else {
          //
          // console.log('ELSE 2. znaci nije ni grpa PROFIL ni LIM');
          if (sema.program && sema.program.mip_is_materijal === true) {
            // if materijal
            // console.log('IF MATERIJAL - sema.program.mip_is_materijal === true');
            if (virtelschemakey === 'terkk$modul$rogalj') {
              // vec je dodat gore
            } else if (virtel.virtelschemakey === 'terkk$materijalcustom') {
              // custommaterijal
              // vec je dodat gore
              /*
            } else if (virtel.graphpath === '/terkk$klimakomora/terkk$modul/panel/kamenavuna1/kamenavuna1_m') {
              // TODO napraviti bolje resenje u buducnosti za oznacavanej delova
              _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.kamenavuna_m(virtel));
              */
            } else if (virtel.virtelclass === 'terkk$_grupa_lim.1_materijal') {
              // NOVO
              _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.univerzalniMaterijal_od_tergrupa_lim(virtel));
            } else {
              _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.univerzalniMaterijal(virtel));
            }
          } else {
            // if PP
            // console.log('IF PP');
            _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.univerzalniPoluproizvod(virtel));
          }
        }
      }
    } else {
      // SEMA NOT FOUND
      _row_obj = _spakuj_objekat_u_sastavnica_internal_row_arr(element.WARNING_SEMA_NOT_FOUND(virtel));
    }
    /*
    if (virtel.kolicina !== 0) {
      // samo oni kod kojih velicina nije nula idu u sastavnicu.
    }
    */
    // proveru kolicine za sada ne radimo na nivou sastavnice jer se moze desiti da na taj nacin bude obrisan level i ucini sastavnicu nevalidnom! Sve provere kolicina moraju da se vrse u samom datarenderu pre nego se zapocne izrada same sastavnice.
    _row_obj.authorBomRevId = virbom_rev_id; // dodajemo i podatak id revizije u sastavnicu kako bi mogli da koristimo vise sastavnica pri eksportu.
    kompletni_sas_internal.push(_row_obj);

    // nema pozivanje iteracija za children elemente je se koristi virbom_seq koaj je vec poredana tako da childreni idu za parentima pravilnim redosledom sekvence

    // prepare next iteration
    _last_kojigod_ident = '';
    _last_kojigod_bomlevel = false;
    if (typeof _row_obj.Ident === 'string') {
      _last_kojigod_ident = _row_obj.Ident;
      _last_kojigod_bomlevel = virtel.bomlevel;
      // console.log(typeof _row_obj.Ident, _row_obj.Ident);
      // console.log(_last_kojigod_ident, _last_kojigod_bomlevel);
    }

    // }; // end of _dirty_tree_virtel_single
  }); // end of forEach


  console.log('*** iteracije dodavanja redova sastavnice zavrsene - kompletni_sas_internal', kompletni_sas_internal);

  // return gotova satavnica;
  return kompletni_sas_internal;
};


/*
export const _make_sastavnice_sve_from_virbom_seq = (virbom_seq, company_orderkey, company_orderitemnumber, virbom_rev_id, beleskaUzExport) => {
  // NE KORISTE SE VIŠE: Sada se koristi _make_sastavnica_for_ext_api_export
  const kompletni_sas_internal = _make_sastavnica_internal_from_virbom_seq(virbom_seq, virbom_rev_id);
  const sastavnica_for_ext_api_export = _make_sastavnica_for_ext_api_export(kompletni_sas_internal, company_orderkey, company_orderitemnumber, virbom_rev_id, beleskaUzExport);
  //
  return {
    sastavnicaInternal: kompletni_sas_internal,
    sastavnica_for_ext_api_export
  };
};
*/

